import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoTipoGrupoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/exportgrouptype/all.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while types are loading');
        });
    }

}